import React from "react";
import Recruitment from "./HR/Recruitment/Recruitment";

export default function RecruitmentPage() {
  return (
    <div className="px-6 space-y-6 animate-in fade-in duration-300">
      <Recruitment />
    </div>
  );
}
